import { TEnvironment } from './type'

export const environment: TEnvironment = {
  apiUrl: 'https://api.dev.luciapp.ca/',
  env: 'dev',
  production: false,
  oidc: {
    clientId: '7p0p8qikd028aco9t62glebara',
    authority: 'https://cognito-idp.ca-central-1.amazonaws.com/ca-central-1_U2MpMZYhp',
  },
}
